import React from "react";
import { Link } from "react-router-dom";
import "./Navigation.scss";
import AuthMenu from "./AuthMenu";
import { isMobile } from "react-device-detect";

function Navigation() {
  return (
    <nav className={`navigation-bar ${isMobile ? "mobile" : "desktop"}`}>
      <img src='/logo.png' alt='Logo' className='logo' />
      {isMobile ? null : (
        <div className='links-block'>
          <Link to='/' className='active'>
            Casino
          </Link>
          <Link >Live-Casino</Link>
          <Link >V-Sport</Link>
          <Link to='/signup'>Leaderboards</Link>
        </div>
      )}
      <AuthMenu />
    </nav>
  );
}

export default Navigation;
